import * as actions from './actionTypes';

export const changeViewMode = value => {
    return dispatch =>
        dispatch({
            type: actions.VIEW_MODE,
            payload: value
        });
};
